// extracted by mini-css-extract-plugin
export default {"-large":"font-heading-module__-large--VM8CF","fontHeading":"font-heading-module__fontHeading--GHe5L","icon":"font-heading-module__icon--zJrRP"};